import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { MAIN_SITE_URL } from "../config";

function Icon({ name }) {
  switch (name) {
    case "instagram":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <rect x="3" y="3" width="18" height="18" rx="5" stroke="currentColor" strokeWidth="1.8" fill="none" />
          <circle cx="12" cy="12" r="4.2" stroke="currentColor" strokeWidth="1.8" fill="none" />
          <circle cx="17.4" cy="6.6" r="1.2" fill="currentColor" />
        </svg>
      );
    case "facebook":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M14 8h2.5V5H14c-2 0-3.5 1.5-3.5 3.5V10H8v3h2.5v8h3v-8H16l.5-3H13.5V8.5c0-.3.2-.5.5-.5z" fill="currentColor" />
        </svg>
      );
    case "twitter":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M18 3h3l-7.5 8.6L22 21h-6.6l-5.2-6.8L4 21H1l8-9.2L1.6 3h6.8l4.7 6.2L18 3zm-2 16h1.8L7.2 5H5.3L16 19z" fill="currentColor" />
        </svg>
      );
    default:
      return null;
  }
}

function Footer() {
  return (
    <footer id="contactUs" className="footer">
      <div className="footer__top">
        <div className="footer__brand">
          <Logo variant="light" />
          <p className="footer__tag">
            Find your nearest Fashion Factory store across India.
          </p>
        </div>

        <div className="footer__col">
          <h4 className="footer__heading">Contact Us</h4>
          <ul>
            <li>
              <a href="tel:18008910001">1800 891 0001</a>
            </li>
            <li>
              <a href="tel:18001027382">1800 102 7382</a>
            </li>
            <li>
              <a href="mailto:customerservice@ril.com">customerservice@ril.com</a>
            </li>
          </ul>
        </div>

        <div className="footer__col">
          <h4 className="footer__heading">Quick Links</h4>
          <ul>
            <li>
              <a href={MAIN_SITE_URL}>Fashion Factory Home</a>
            </li>
            <li>
              <Link to="/">Store Locator</Link>
            </li>
            <li>
              <a href={`${MAIN_SITE_URL}/terms`}>Terms &amp; Conditions</a>
            </li>
            <li>
              <a href={`${MAIN_SITE_URL}/privacy`}>Privacy Policy</a>
            </li>
          </ul>
        </div>

        <div className="footer__col">
          <h4 className="footer__heading">Follow Us</h4>
          <div className="footer__social">
            <a
              href="https://www.instagram.com/reliance_fashionfactory/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="footer__social-link"
            >
              <Icon name="instagram" />
            </a>
            <a
              href="https://m.facebook.com/rel.fashionfactory"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="footer__social-link"
            >
              <Icon name="facebook" />
            </a>
            <a
              href="https://twitter.com/FashionF_IND"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Twitter"
              className="footer__social-link"
            >
              <Icon name="twitter" />
            </a>
          </div>
        </div>
      </div>
      <div className="footer__bottom">
        <span>
          &copy; {new Date().getFullYear()} Reliance Retail Ltd. All rights reserved.
        </span>
        <span>Store Locator · A Reliance Retail format</span>
      </div>
    </footer>
  );
}

export default Footer;
